// extracted by mini-css-extract-plugin
export var boxItems = "_9w-1";
export var boxItemsLg = "_9w-2";
export var button = "_9w-7";
export var buttonHoverless = "_9w-9";
export var buttonLg = "_9w-8";
export var filterGroupBox = "_9w-0";
export var icon = "_9w-3";
export var iconSecondary = "_9w-6";
export var iconWrapper = "_9w-4";
export var iconWrapperLg = "_9w-5";
export var truncatedLabel = "_9w-a";